// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file catpocs/v1/admin.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import { AdminService } from "./admin_pb";

/**
 * ListAllProjects lists all projects (admin only)
 *
 * @generated from rpc catpocs.v1.AdminService.ListAllProjects
 */
export const listAllProjects = AdminService.method.listAllProjects;

/**
 * GetAuditLogs retrieves audit logs with enhanced filtering
 *
 * @generated from rpc catpocs.v1.AdminService.GetAuditLogs
 */
export const getAuditLogs = AdminService.method.getAuditLogs;

/**
 * GetOperatorMetrics retrieves operator metrics
 *
 * @generated from rpc catpocs.v1.AdminService.GetOperatorMetrics
 */
export const getOperatorMetrics = AdminService.method.getOperatorMetrics;

/**
 * ValidateRepository validates a GitHub repository
 *
 * @generated from rpc catpocs.v1.AdminService.ValidateRepository
 */
export const validateRepository = AdminService.method.validateRepository;

/**
 * GetSystemHealth retrieves system health status (ArgoCD, K8s, GitHub, etc.)
 *
 * @generated from rpc catpocs.v1.AdminService.GetSystemHealth
 */
export const getSystemHealth = AdminService.method.getSystemHealth;

/**
 * ListActiveSessions lists all active user sessions with pagination (admin only)
 *
 * @generated from rpc catpocs.v1.AdminService.ListActiveSessions
 */
export const listActiveSessions = AdminService.method.listActiveSessions;

/**
 * RevokeSession revokes a specific session (admin only)
 *
 * @generated from rpc catpocs.v1.AdminService.RevokeSession
 */
export const revokeSession = AdminService.method.revokeSession;

/**
 * RevokeUserSessions revokes all sessions for a user (admin only)
 *
 * @generated from rpc catpocs.v1.AdminService.RevokeUserSessions
 */
export const revokeUserSessions = AdminService.method.revokeUserSessions;

/**
 * ListUsers lists all users with detailed information and filtering (admin only)
 *
 * @generated from rpc catpocs.v1.AdminService.ListUsers
 */
export const listUsers = AdminService.method.listUsers;

/**
 * GetUserStatistics retrieves aggregate user statistics (admin only)
 *
 * @generated from rpc catpocs.v1.AdminService.GetUserStatistics
 */
export const getUserStatistics = AdminService.method.getUserStatistics;

/**
 * StartImpersonation starts impersonating a user (super admin only)
 *
 * @generated from rpc catpocs.v1.AdminService.StartImpersonation
 */
export const startImpersonation = AdminService.method.startImpersonation;

/**
 * StopImpersonation stops impersonating a user
 *
 * @generated from rpc catpocs.v1.AdminService.StopImpersonation
 */
export const stopImpersonation = AdminService.method.stopImpersonation;
